import { render } from "./VikingsMaps.vue?vue&type=template&id=8bab6af0"
import script from "./VikingsMaps.vue?vue&type=script&lang=js"
export * from "./VikingsMaps.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__